import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { convertToJalali } from "../../../utils/date";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";

//import images and icons
import { Airplane, Location } from "iconsax-react";

//import styles
import "./confirm.scss";

function IntFlightInformation({ title, details, iconName }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid container item xs={12} justifyContent="center">
            <Grid className={`confirm__title ${iconName}`} container item xs={6} justifyContent="center">
                <Airplane color="var(--light-color)" variant="Bold" />
                {title}
            </Grid>

            <Grid className="confirm container" container item xs={12} justifyContent="space-between" alignItems="flex-start">
                {details?.map(segment => {
                    return (
                        <Grid container item xs="auto" rowGap={2} direction="column" justifyContent="center" alignItems="center">
                            <Grid component="img" src={segment?.airline?.image} container item xs="auto" />
                            <span className="confirm__point"></span>
                            <div className="confirm__details" container item xs="auto">
                                <Grid container item xs={12}>
                                    {t("airport")}: {locale === "en" ? segment?.departure?.terminal?.code : segment?.departure?.terminal?.name}
                                </Grid>
                                <Divider width="100%" sx={{ borderBottomColor: "var(--primary-color-20)" }} />
                                <Grid container item xs={12}>
                                    {t("departureTimeDate")}: {locale === "en" ? segment?.departure_date : convertToJalali(segment?.departure_date)} ,{" "}
                                    {segment?.departure_time}
                                </Grid>
                                <Divider width="100%" sx={{ borderBottomColor: "var(--primary-color-20)" }} />
                                <Grid container item xs={12}>
                                    {t("airline")}: {locale === "en" ? segment?.airline?.english : segment?.airline?.persian}
                                </Grid>
                            </div>
                        </Grid>
                    );
                })}
                <Grid container item xs="auto" rowGap={2} direction="column" justifyContent="center" alignItems="center">
                    <Location size="32" color="var(--primary-color)" variant="Bold" />
                    <span className="confirm__point"></span>
                    <div className="confirm__details" container item xs="auto">
                        <Grid container item xs={12}>
                            {t("airport")}:{" "}
                            {locale === "en"
                                ? details[details.length - 1]?.destination?.terminal?.code
                                : details[details.length - 1]?.destination?.terminal?.name}
                        </Grid>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--primary-color-20)" }} />
                        <Grid container item xs={12}>
                            {t("departureTimeDate")}:{" "}
                            {locale === "en" ? details[details.length - 1]?.arrival_date : convertToJalali(details[details.length - 1]?.arrival_date)}{" "}
                            , {details[details.length - 1]?.destination_time}
                        </Grid>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--primary-color-20)" }} />
                        <Grid container item xs={12}>
                            {t("airline")}:{" "}
                            {locale === "en" ? details[details?.length - 1]?.airline?.english : details[details?.length - 1]?.airline?.persian}
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default IntFlightInformation;
